import { render, staticRenderFns } from "./businessStage.vue?vue&type=template&id=fc7ac0b4&scoped=true"
import script from "./businessStage.vue?vue&type=script&lang=js"
export * from "./businessStage.vue?vue&type=script&lang=js"
import style0 from "./businessStage.vue?vue&type=style&index=0&id=fc7ac0b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7ac0b4",
  null
  
)

export default component.exports